import { useState, useEffect, useCallback } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { processSyncQueue } from '@/lib/sync';
import { db } from '@/lib/offline-db';

// Online/Offline Status + automatischer Sync
export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const triggerSync = useCallback(() => {
    processSyncQueue().catch(console.error);
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      triggerSync();
    };
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [triggerSync]);

  return isOnline;
}

// Reaktive Anzahl ausstehender Sync-Aktionen via Dexie liveQuery
export function useSyncQueueCount(): number {
  return useLiveQuery(() => db.sync_queue.count(), [], 0);
}
